import { StyledSpinnerLabel } from '@integration/alexandria-ui';
import { useTranslateByProject } from 'hooks/translation-hooks';

export const LoaderLabel = ({ label }: { label: string }) => {
  const t = useTranslateByProject();
  return <StyledSpinnerLabel>{t(label)}</StyledSpinnerLabel>;
};
